import { render, staticRenderFns } from "./LogPembayaran.vue?vue&type=template&id=6b0b6988&"
import script from "./LogPembayaran.vue?vue&type=script&lang=js&"
export * from "./LogPembayaran.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports